export default "__VITE_ASSET___eWFiXjK__"